import { SetContextLink } from '@apollo/client/link/context';
import { isNonEmptyString } from '@sniptt/guards';

type CreateAuthLinkArgs = {
  getAuthToken: () => Promise<string | null>;
};

// Where sign-in plugs in. With Clerk, getAuthToken is Clerk's getToken(),
// called for every request so the token is always fresh (Clerk refreshes it
// before it expires). With the server's mock sign-in it returns null and no
// header is sent.
export const createAuthLink = ({ getAuthToken }: CreateAuthLinkArgs) =>
  new SetContextLink(async ({ headers }) => {
    const authToken = await getAuthToken();

    if (!isNonEmptyString(authToken)) {
      return {};
    }

    return { headers: { ...headers, authorization: `Bearer ${authToken}` } };
  });
